import { default as CreateActivityButton } from './CreateActivityButton';
import { default as CreateActivityPopover } from '../popover/CreateActivityPopover';
import { jsx as _jsx } from "react/jsx-runtime";
const PopoverActivityButton = ({
  // CreateActivityButton props
  buttonProps,
  buttonSize,
  dataTestId,
  disabled,
  onboardingSelector,
  seleniumSelector,
  tooltipMessage,
  objectTypeId,
  objectId,
  showCarrot,
  windowVariant,
  // Shared props
  interactionName,
  isLoading,
  isOverflow,
  // Popover props
  closeOnOutsideClick,
  content,
  onPopoverToggle,
  open
}) => {
  return /*#__PURE__*/_jsx(CreateActivityPopover, {
    closeOnOutsideClick: closeOnOutsideClick,
    content: content,
    interactionName: interactionName,
    isOverflow: isOverflow,
    onPopoverToggle: onPopoverToggle,
    open: open,
    children: /*#__PURE__*/_jsx(CreateActivityButton, {
      buttonProps: buttonProps,
      buttonSize: buttonSize,
      dataTestId: dataTestId,
      disabled: disabled,
      interactionName: interactionName,
      isLoading: isLoading,
      isOverflow: isOverflow,
      onboardingSelector: onboardingSelector,
      seleniumSelector: seleniumSelector,
      showCarrot: showCarrot,
      tooltipMessage: tooltipMessage,
      objectTypeId: objectTypeId,
      objectId: objectId,
      windowVariant: windowVariant
    })
  });
};
export default PopoverActivityButton;